module.exports = __webpack_public_path__ + "static/media/news_attention.ef10c7ee.svg";